<template>
    <div class="flex">
        <datepicker id="days" :name="name" ref="datepicker"
            v-validate="'required'"
            :format="'yyyy-MM-dd'"
            v-model="selector.day"
            @selected="dateSelected"
            class="flex-1 items-center"
        >
        </datepicker>
        <a href="#" @click.stop.prevent="removeDay">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="35" height="35" viewBox="0 0 100 100"><g><g transform="translate(50 50) scale(0.69 0.69) rotate(0) translate(-50 -50)" style="fill:#000000"><svg fill="#000000" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 100 100" style="enable-background:new 0 0 100 100;" xml:space="preserve"><rect x="33.1" y="38.8" width="5.6" height="45"></rect><rect x="47.2" y="38.8" width="5.6" height="45"></rect><rect x="61.2" y="38.8" width="5.6" height="45"></rect><path d="M86.6,16.2H66.9V5H33.1v11.2H13.4v16.9H19V95h61.9V33.1h5.6L86.6,16.2L86.6,16.2z M38.8,10.6h22.5v5.6H38.8V10.6z   M19.1,21.9h14.1H67h14.1v5.6h-62V21.9z M75.3,89.4H24.7V33.1h50.6V89.4z"></path></svg></g></g></svg>
        </a>
    </div>
</template>

<script>
    import Datepicker from "vuejs-datepicker";

    export default {
        name: "DaySelector",
        $_veeValidate: {
            // value getter
            value() {
                return this.selector.day;
                // return this.$el.value;
            },
            // name getter
            name() {
                return this.name;
            }
        },
        props: {
            name: String,
            value: Object,
            arrayIndex: [Number, String]
        },
        components: {
            Datepicker
        },
        data: () => ({
            selector: {
                day: null
            }
        }),
        methods: {
            focus() {
                this.$refs.datepicker.focus();
            },
            removeDay() {
                if (this.selector.id && !isNaN(this.selector.id)) {
                    let route = this.$laroute.route("api.days.destroy", {
                        day: this.selector.id
                    });

                    axios.delete(route).then(response => {
                        this.$toasted.show("Date has been deleted");
                    });
                }

                this.$emit("remove-day", this.arrayIndex);
            },
            dateSelected(value) {
                this.selector.day = value;
                this.$emit("input", this.selector);
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.selector = Object.assign({}, this.selector, this.value);

                if (this.selector.day) {
                    this.selector.day = new Date(`${this.value.day}T13:00:00`);
                }
            });
        }
    };
</script>
